/** Тип оплаты */
export enum PaymentTypeForOrder {
  /** Оплата картой */
  Card,
  /** Безналичный расчет */
  NonCash,
  /** Оплата в рассрочку */
  Installment,
  /** Сбербанк Онлайн */
  SberOnline,
  /** Оплата в рассрочку Тинькофф */
  TinkoffInstallment,
  /**Оплата сплитом yandex.pay */
  YandexPay
}